module.exports = __webpack_public_path__ + "img/F.9a281ced.svg";